module.exports = __webpack_public_path__ + "static/img/technology4.2ace33fa.png";